import { Box, Button, Typography } from '@mui/material';

export const EmptyState = ({
  title = 'No hay información para mostrar',
  description = 'Cuando haya registros en Acércate, aparecerán aquí.',
  actionLabel,
  onAction,
}) => (
  <Box sx={{ textAlign: 'center', py: 6, px: 2 }}>
    <Typography variant="h6" component="h2" sx={{ fontWeight: 700 }}>
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 2 }}>
      {description}
    </Typography>
    {actionLabel && onAction && (
      <Button variant="text" color="primary" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </Box>
);
